import React, { Component } from "react";
import { connect } from "react-redux";
import Info from "../shared/Info";
import {
  addFeedbacks,
  getMemberFeks,
  selectWorkflow,
  clearMemberFek,
  getMemberIbans,
  clearMemberIban,

} from "../../../state/ducks/workflow/index";
import $ from "jquery";
import KvkkModal from "../shared/KvkkModal";
import EminevimLoading from "../shared/EminevimLoading";
import LoginPageAlert from "../Login/LoginPageAlert";
import AppCustomSelect from "../shared/AppCustomSelect";
import {
  getCustomSelectLabel,
  getCustomSelectValue,
  setCustomSelectFieldState,
} from "../../../utils/customSelect";

const TALEP_OPTIONS = [
  { value: "0", label: "Seçiniz" },
  { value: "1", label: "Şikayet" },
  { value: "2", label: "Talep" },
  { value: "3", label: "Öneri" },
  { value: "4", label: "Memnuniyet" },
  { value: "5", label: "Araç Rehin Fek" },
  { value: "6", label: "Konut İpotek Fek" },
  { value: "7", label: "Satıcı IBAN Girişi" },
];

function oneriFormKontrol() {
  var konu = $("#konu").val();
  var mesaj = $("#mesaj").val();
  var selectTalep = getCustomSelectLabel("talep");
  var selectUyeNo = getCustomSelectLabel("uyeNo");
  var selectUyeNoIban = getCustomSelectLabel("uyeNoIban");
  var selectedSaticiTuru = getCustomSelectLabel("saticiTuru");

  var adiSoyadi = $("#adiSoyadi").val();
  var tckn = $("#tckn").val();
  var babaAdi = $("#babaAdi").val();

  var unvan = $("#unvan").val();
  var vkn = $("#vkn").val();
  var mersisNo = $("#mersisNo").val();

  var iban = $("#iban").val();
  var phone = $("#phone").val();

  var durum = 1;

  // konu boş mu kontrol
  if (selectTalep == "Seçiniz") {
    durum = 0;
    setCustomSelectFieldState("talep", true);
    $("#talep_hatamesaj").html("Başvuru nedeni boş bırakılamaz");
  } else {
    setCustomSelectFieldState("talep", false);
    $("#talep_hatamesaj").html("");
  }

  if (selectTalep == "Araç Rehin Fek" || selectTalep == "Konut İpotek Fek") {
    if (document.getElementById("uyeNo") && (["", "0"].includes(getCustomSelectValue("uyeNo")) || selectUyeNo == "Seçiniz")) {
      durum = 0;
      setCustomSelectFieldState("uyeNo", true);
      $("#uyeNo_hatamesaj").html("Üyelik bilgisi boş bırakılamaz");
    } else if (document.getElementById("uyeNo")) {
      setCustomSelectFieldState("uyeNo", false);
      $("#uyeNo_hatamesaj").html("");
    }
  }

  if (selectTalep == "Satıcı IBAN Girişi") {
    if (selectedSaticiTuru == "Seçiniz") {
      durum = 0;
      setCustomSelectFieldState("saticiTuru", true);
      $("#saticiTuru_hatamesaj").html("Satıcı Türü boş bırakılamaz");
    } else {
      setCustomSelectFieldState("saticiTuru", false);
      $("#saticiTuru_hatamesaj").html("");
    }

    if (selectUyeNoIban == "Seçiniz") {
      durum = 0;
      setCustomSelectFieldState("uyeNoIban", true);
      $("#uyeNoIban_hatamesaj").html("Uyelik bilgisi boş bırakılamaz");
    } else {
      setCustomSelectFieldState("uyeNoIban", false);
      $("#uyeNoIban_hatamesaj").html("");
    }

    if (selectedSaticiTuru == "Bireysel") {


      if (adiSoyadi == "") {
        durum = 0; // Konu Boş
        $("#adiSoyadi").parent().addClass("t-error");
        $("#adiSoyadi").next().html("<i class='t-icon-error text-danger'></i>");
        $("#adiSoyadi_hatamesaj").html("Satıcı Adı Soyadı alanı boş bırakılamaz");
      } else {
        $("#adiSoyadi").parent().removeClass("t-error");
        $("#adiSoyadi").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#adiSoyadi_hatamesaj").html("");
      }


      if (tckn == "") {
        durum = 0; // Konu Boş
        $("#tckn").parent().addClass("t-error");
        $("#tckn").next().html("<i class='t-icon-error text-danger'></i>");
        $("#tckn_hatamesaj").html("Satıcı TCKN alanı boş bırakılamaz");
      } else {
        $("#tckn").parent().removeClass("t-error");
        $("#tckn").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#tckn_hatamesaj").html("");
      }

      if (babaAdi == "") {
        durum = 0; // Konu Boş
        $("#babaAdi").parent().addClass("t-error");
        $("#babaAdi").next().html("<i class='t-icon-error text-danger'></i>");
        $("#babaAdi_hatamesaj").html("Satıcı Baba Adı alanı boş bırakılamaz");
      } else {
        $("#babaAdi").parent().removeClass("t-error");
        $("#babaAdi").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#babaAdi_hatamesaj").html("");
      }
    }

    if (selectedSaticiTuru == "Kurumsal") {



      if (unvan == "") {
        durum = 0; // Konu Boş
        $("#unvan").parent().addClass("t-error");
        $("#unvan").next().html("<i class='t-icon-error text-danger'></i>");
        $("#unvan_hatamesaj").html("Satıcı Ünvan alanı boş bırakılamaz");
      } else {
        $("#unvan").parent().removeClass("t-error");
        $("#unvan").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#unvan_hatamesaj").html("");
      }


      if (vkn == "") {
        durum = 0; // Konu Boş
        $("#vkn").parent().addClass("t-error");
        $("#vkn").next().html("<i class='t-icon-error text-danger'></i>");
        $("#vkn_hatamesaj").html("Satıcı VKN alanı boş bırakılamaz");
      } else {
        $("#vkn").parent().removeClass("t-error");
        $("#vkn").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#vkn_hatamesaj").html("");
      }
    }

    if (phone == "") {
      durum = 0; // Konu Boş
      $("#phone").parent().addClass("t-error");
      $("#phone").next().html("<i class='t-icon-error text-danger'></i>");
      $("#phone_hatamesaj").html("Satıcı Telefon Numarası alanı boş bırakılamaz");
    } else {
      $("#phone").parent().removeClass("t-error");
      $("#phone").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
      $("#phone_hatamesaj").html("");
    }

    iban = iban.replace(/\s/g, "");
    const ibanRegex = /^TR[0-9]{24}$/;
    if (!ibanRegex.test(iban)) {
      durum = 0; // Konu Boş
      $("#iban").parent().addClass("t-error");
      $("#iban").next().html("<i class='t-icon-error text-danger'></i>");
      $("#iban_hatamesaj").html("Satıcı IBAN alanını geçerli bir değer giriniz");
    } else if (iban == "") {
      durum = 0; // Konu Boş
      $("#iban").parent().addClass("t-error");
      $("#iban").next().html("<i class='t-icon-error text-danger'></i>");
      $("#iban_hatamesaj").html("Satıcı IBAN alanı boş bırakılamaz");
    } else {
      $("#iban").parent().removeClass("t-error");
      $("#iban").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
      $("#iban_hatamesaj").html("");
    }

  } else {

  }

  // konu boş mu kontrol
  if (konu == "") {
    durum = 0; // Konu Boş
    $("#konu").parent().addClass("t-error");
    $("#konu").next().html("<i class='t-icon-error text-danger'></i>");
    $("#konu_hatamesaj").html("Konu alanı boş bırakılamaz");
  } else {
    $("#konu").parent().removeClass("t-error");
    $("#konu").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#konu_hatamesaj").html("");
  }
  // Açıklama boş mu kontrol
  if (mesaj == "" && selectTalep != "Satıcı IBAN Girişi") {
    durum = 0; // Mesaj Boş
    $("#mesaj").parent().addClass("t-error");
    $("#mesaj").next().html("<i class='t-icon-error text-danger'></i>");
    $("#mesaj_hatamesaj").html("Mesaj alanı boş bırakılamaz");
  } else {
    $("#mesaj").parent().removeClass("t-error");
    $("#mesaj").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#mesaj_hatamesaj").html("");
  };
  return durum;
}

export class SubmitDemand extends Component {
  state = {
    subject: "",
    description: "",
    reason: "0",
    memberNo: "0",
    memberFekList: [],
    isSubjectReadonly: true,
    kvkkMetni: "",
    isKvkkModalOpen: false,
    memberIbanList: [],

    nameSurname: "",
    tckn: "",
    fatherName: "",

    unvan: "",
    vkn: "",
    mersisNo: "",

    iban: "",
    phone: "",

    saticiTuru: "0",
    shouldAnimateCard: false,
    isProcessing: false,
    kvkkAccepted: false,
    formErrors: {
      kvkk: "",
    },
    formAlert: null,
  };
  componentDidMount() {
    this.setState({ memberNo: "0", saticiTuru: "0", shouldAnimateCard: true });
    this.props.clearMemberFek();
    this.props.clearMemberIban();
    window.setTimeout(() => this.setState({ shouldAnimateCard: false }), 900);
  }
  onSubmit = (e) => {
    e.preventDefault();

    const kvkkError = !this.state.kvkkAccepted ? "Devam etmek için onaylamalısınız" : "";

    if (oneriFormKontrol() === 0 || kvkkError) {
      this.setState({ formErrors: { kvkk: kvkkError } });
      return false;
    }

    this.setState({ isProcessing: true, formErrors: { kvkk: "" }, formAlert: null });
    Promise.resolve(
      this.props.addFeedbacks(
        this.state.subject,
        this.state.description,
        this.state.reason,
        this.state.memberNo,

        this.state.nameSurname,
        this.state.tckn,
        this.state.fatherName,

        this.state.unvan,
        this.state.vkn,
        this.state.mersisNo,

        this.state.iban,
        this.state.phone,
      )
    )
      .then((result) => {
        if (result?.success === false && result.message) {
          this.setState({
            formAlert: {
              type: "error",
              messages: [result.message],
            },
          });
        }
      })
      .finally(() => {
        this.setState({ isProcessing: false });
      });
  };

  clearFormAlert = () => {
    this.setState({ formAlert: null });
  };
  componentDidUpdate(prevProps) {
    if (
      (this.state.reason === "5" || this.state.reason === "6") &&
      prevProps.isLoading &&
      !this.props.isLoading
    ) {
      const memberFekList = Array.isArray(this.props.memberFek) ? this.props.memberFek : [];

      if (memberFekList.length === 0) {
        setCustomSelectFieldState("talep", true);
        $("#talep_hatamesaj").html(
          "Üyelik bulunamadı. Araç Rehin Fek ya da Konut İpotek Fek talebi açılamaz."
        );
      } else {
        setCustomSelectFieldState("talep", false);
        $("#talep_hatamesaj").html("");
      }
    }

    if (
      this.state.reason === "7" &&
      prevProps.isLoading &&
      !this.props.isLoading
    ) {
      const memberIbanList = Array.isArray(this.props.memberIban) ? this.props.memberIban : [];

      if (memberIbanList.length === 0) {
        setCustomSelectFieldState("talep", true);
        $("#talep_hatamesaj").html(
          "Üyelik bulunamadı. Satıcı IBAN Girişi talebi açılamaz."
        );
      } else {
        setCustomSelectFieldState("talep", false);
        $("#talep_hatamesaj").html("");
      }
    }

    // ❗ Form resetleme sadece error yeni geldiyse yapılmalı
    if (
      this.props.workflow?.feedbackErrorMessage &&
      prevProps.workflow?.feedbackErrorMessage !== this.props.workflow.feedbackErrorMessage
    ) {
      this.setState({
        subject: "",
        description: "",
        reason: "0",
        memberNo: "0",
        isSubjectReadonly: true,

        nameSurname: "",
        tckn: "",
        fatherName: "",

        unvan: "",
        vkn: "",
        mersisNo: "",

        iban: "",
        phone: "",

        saticiTuru: "0",
        kvkkAccepted: false,
        formErrors: { kvkk: "" },
        formAlert: this.props.workflow?.feedbackErrorMessage
          ? {
              type: "error",
              messages: [this.props.workflow.feedbackErrorMessage],
            }
          : null,
      });
      this.props.clearMemberFek();
      this.props.clearMemberIban();
      $("#konu").val("");
      $("#mesaj").val("");
      $("#talep_hatamesaj").html("");
    }
  }

  getKvkk = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.setState({ isKvkkModalOpen: true });
  };

  handleKvkkLoaded = (kvkkMetni) => {
    this.setState({ kvkkMetni });
  };

  closeKvkkModal = () => {
    this.setState({ isKvkkModalOpen: false });
  };

  renderFormField = (label, icon, control, errorId, htmlFor) => (
    <div className="t-resetPassword-field">
      {label && (
        <label htmlFor={htmlFor} className="t-resetPassword-label">
          {label}
        </label>
      )}
      <div className="t-resetPassword-inputWrap t-submitDemand-inputWrap">
        <div>
          <i className={icon} aria-hidden="true" />
        </div>
        {control}
        <div />
      </div>
      <div className="t-icinputHatamesajArea t-resetPassword-error" id={errorId} />
    </div>
  );

  renderTextareaField = (label, icon, control, errorId, htmlFor) => (
    <div className="t-resetPassword-field">
      {label && (
        <label htmlFor={htmlFor} className="t-resetPassword-label">
          {label}
        </label>
      )}
      <div className="t-resetPassword-inputWrap t-submitDemand-inputWrap t-submitDemand-inputWrap--textarea">
        <div>
          <i className={icon} aria-hidden="true" />
        </div>
        {control}
        <div />
      </div>
      <div className="t-icinputHatamesajArea t-resetPassword-error" id={errorId} />
    </div>
  );

  getLoadingSubtext = () => {
    if (this.state.isProcessing) {
      return "Talebiniz gönderiliyor, lütfen bekleyiniz.";
    }

    if (this.props.isLoading) {
      return "Üyelik bilgileriniz hazırlanıyor, lütfen bekleyiniz.";
    }

    return "İşleminiz gerçekleştiriliyor, lütfen bekleyiniz.";
  };

  render() {
    const { workflow, isLoading } = this.props;
    if (workflow?.addedFeedback) {
      return (
        <Info
          header={"Talebiniz alınmıştır."}
          body={
            "Talebiniz ile ilgili gelişmeleri 'Talep Takibi' menüsünden takip edebilirsiniz."
          }
        ></Info>
      );
    } else {
      const { shouldAnimateCard, isProcessing } = this.state;
      const showLoadingOverlay = isProcessing || isLoading;

      return (
        <div className="t-submitDemand-page" style={{ background: "#ffffff" }}>
          <div className="row" style={{ padding: "3%" }}>
            <div className="col-12">
              <div className="t-memberInfo-pageHeader">
                <h1 className="t-memberInfo-pageTitle">Öneri ve İstekleriniz</h1>
                <p className="t-memberInfo-pageSubtitle">
                  Öneri, talep veya şikayetlerinizi iletebilir; fek ve IBAN işlemlerinizi buradan başlatabilirsiniz.
                </p>
              </div>

              <article
                className={`t-memberInfo-card t-memberDetail-header--green${
                  shouldAnimateCard ? " t-memberInfo-card--enter" : ""
                }`}
              >
              

                <form
                  className="t-resetPassword-form t-submitDemand-form"
                  onSubmit={this.onSubmit}
                  noValidate
                >
                  {this.state.formAlert ? (
                    <LoginPageAlert
                      messages={this.state.formAlert.messages}
                      type={this.state.formAlert.type}
                      onDismiss={this.clearFormAlert}
                    />
                  ) : null}

                  {this.renderFormField(
                    "Başvuru Nedeniniz",
                    "t-icon-lock1",
                    (
                      <AppCustomSelect
                        id="talep"
                        value={this.state.reason}
                        placeholder="Seçiniz"
                        options={TALEP_OPTIONS}
                        onChange={(value) => {
                          const selectTalep =
                            TALEP_OPTIONS.find((option) => option.value === value)?.label || "";
                          this.setState({ reason: value, saticiTuru: "0" });

                          if (value === "5" || value === "6") {
                            this.setState({
                              memberNo: "0",
                              subject: selectTalep,
                              isSubjectReadonly: true,
                            });
                            setCustomSelectFieldState("talep", false);
                            $("#talep_hatamesaj").html("");
                            $("#uyeNo_hatamesaj").html("");
                            this.props.clearMemberIban();
                            this.props.getMemberFeks(value);
                          }
                          if (value === "7") {
                            this.setState({
                              memberNo: "0",
                              subject: selectTalep,
                              isSubjectReadonly: true,
                            });
                            setCustomSelectFieldState("talep", false);
                            $("#talep_hatamesaj").html("");
                            $("#uyeNoIban_hatamesaj").html("");
                            this.props.clearMemberFek();
                            this.props.getMemberIbans(value);
                          } else if (value !== "5" && value !== "6" && value !== "7") {
                            setCustomSelectFieldState("uyeNo", false);
                            $("#talep_hatamesaj").html("");
                            this.setState({ memberNo: "0", subject: "", isSubjectReadonly: false });
                            this.props.clearMemberFek();
                            this.props.clearMemberIban();
                          }
                        }}
                      />
                    ),
                    "talep_hatamesaj",
                    "talep"
                  )}

                  {(this.state.reason === "5" || this.state.reason === "6") &&
                    Array.isArray(this.props.memberFek) &&
                    this.props.memberFek.length > 0 &&
                    this.renderFormField(
                      "Üyelik Bilgisi",
                      "t-icon-user",
                      (
                        <AppCustomSelect
                          id="uyeNo"
                          value={this.state.memberNo}
                          placeholder="Seçiniz"
                          options={[
                            { value: "0", label: "Seçiniz" },
                            ...this.props.memberFek.map((item) => ({
                              value: String(item.id),
                              label: item.adi,
                            })),
                          ]}
                          onChange={(nextValue) => this.setState({ memberNo: nextValue })}
                        />
                      ),
                      "uyeNo_hatamesaj",
                      "uyeNo"
                    )}

                  {this.renderFormField(
                    "Konu",
                    "t-icon-pen1",
                    (
                      <input
                        type="text"
                        id="konu"
                        name="konu"
                        placeholder="Konu başlığınızı yazınız"
                        required
                        maxLength="200"
                        value={this.state.subject}
                        readOnly={this.state.isSubjectReadonly}
                        onChange={(e) => {
                          this.setState({ subject: e.target.value });
                        }}
                      />
                    ),
                    "konu_hatamesaj",
                    "konu"
                  )}

                  {this.state.reason === "7" && (
                    <div className="t-submitDemand-section">
                      {this.renderFormField(
                        "Üyelik Bilgisi",
                        "t-icon-user",
                        (
                          <AppCustomSelect
                            id="uyeNoIban"
                            value={this.state.memberNo}
                            placeholder="Seçiniz"
                            options={[
                              { value: "0", label: "Seçiniz" },
                              ...(Array.isArray(this.props.memberIban) ? this.props.memberIban : []).map((item) => ({
                                value: String(item.id),
                                label: item.adi,
                              })),
                            ]}
                            onChange={(nextValue) => this.setState({ memberNo: nextValue })}
                          />
                        ),
                        "uyeNoIban_hatamesaj",
                        "uyeNoIban"
                      )}

                      {this.renderFormField(
                        "Satıcı Türü",
                        "t-icon-lock1",
                        (
                          <AppCustomSelect
                            id="saticiTuru"
                            value={this.state.saticiTuru}
                            placeholder="Seçiniz"
                            options={[
                              { value: "0", label: "Seçiniz" },
                              { value: "1", label: "Bireysel" },
                              { value: "2", label: "Kurumsal" },
                            ]}
                            onChange={(nextValue) => this.setState({ saticiTuru: nextValue })}
                          />
                        ),
                        "saticiTuru_hatamesaj",
                        "saticiTuru"
                      )}

                      {this.state.saticiTuru === "1" && (
                        <>
                          {this.renderFormField(
                            "Satıcı Adı Soyadı",
                            "t-icon-pen1",
                            (
                              <input
                                type="text"
                                id="adiSoyadi"
                                name="adiSoyadi"
                                placeholder="Satıcı adı soyadı yazınız"
                                required
                                maxLength="200"
                                value={this.state.nameSurname}
                                onChange={(e) => {
                                  this.setState({ nameSurname: e.target.value });
                                }}
                              />
                            ),
                            "adiSoyadi_hatamesaj",
                            "adiSoyadi"
                          )}

                          {this.renderFormField(
                            "Satıcı TC Kimlik No",
                            "t-icon-pen1",
                            (
                              <input
                                type="text"
                                id="tckn"
                                name="tckn"
                                placeholder="Satıcı TC kimlik no yazınız"
                                required
                                maxLength="11"
                                value={this.state.tckn}
                                onChange={(e) => {
                                  const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                                  this.setState({ tckn: onlyNumbers });
                                }}
                              />
                            ),
                            "tckn_hatamesaj",
                            "tckn"
                          )}

                          {this.renderFormField(
                            "Satıcı Baba Adı",
                            "t-icon-pen1",
                            (
                              <input
                                type="text"
                                id="babaAdi"
                                name="babaAdi"
                                placeholder="Satıcı baba adını yazınız"
                                required
                                maxLength="200"
                                value={this.state.fatherName}
                                onChange={(e) => {
                                  this.setState({ fatherName: e.target.value });
                                }}
                              />
                            ),
                            "babaAdi_hatamesaj",
                            "babaAdi"
                          )}
                        </>
                      )}

                      {this.state.saticiTuru === "2" && (
                        <>
                          {this.renderFormField(
                            "Satıcı Ünvan",
                            "t-icon-pen1",
                            (
                              <input
                                type="text"
                                id="unvan"
                                name="unvan"
                                placeholder="Satıcı ünvanı yazınız"
                                required
                                maxLength="500"
                                value={this.state.unvan}
                                onChange={(e) => {
                                  this.setState({ unvan: e.target.value });
                                }}
                              />
                            ),
                            "unvan_hatamesaj",
                            "unvan"
                          )}

                          {this.renderFormField(
                            "Satıcı VKN",
                            "t-icon-pen1",
                            (
                              <input
                                type="text"
                                id="vkn"
                                name="vkn"
                                placeholder="Satıcı VKN yazınız"
                                required
                                maxLength="10"
                                value={this.state.vkn}
                                onChange={(e) => {
                                  const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                                  this.setState({ vkn: onlyNumbers });
                                }}
                              />
                            ),
                            "vkn_hatamesaj",
                            "vkn"
                          )}

                          {this.renderFormField(
                            "Satıcı Mersis No",
                            "t-icon-pen1",
                            (
                              <input
                                type="text"
                                id="mersisNo"
                                name="mersisNo"
                                placeholder="Satıcı Mersis No yazınız"
                                required
                                maxLength="16"
                                value={this.state.mersisNo}
                                onChange={(e) => {
                                  this.setState({ mersisNo: e.target.value });
                                }}
                              />
                            ),
                            "mersisNo_hatamesaj",
                            "mersisNo"
                          )}
                        </>
                      )}

                      {(this.state.saticiTuru === "1" || this.state.saticiTuru === "2") && (
                        <>
                          {this.renderFormField(
                            "Satıcı Tel No",
                            "t-icon-pen1",
                            (
                              <input
                                type="text"
                                id="phone"
                                name="phone"
                                placeholder="Satıcı tel no"
                                required
                                maxLength="10"
                                value={this.state.phone}
                                onChange={(e) => {
                                  const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                                  this.setState({ phone: onlyNumbers });
                                }}
                              />
                            ),
                            "phone_hatamesaj",
                            "phone"
                          )}

                          {this.renderFormField(
                            "Satıcı IBAN",
                            "t-icon-pen1",
                            (
                              <input
                                type="text"
                                id="iban"
                                name="iban"
                                placeholder="TR ---- ---- ---- ---- ---- ----"
                                required
                                maxLength="32"
                                value={this.state.iban}
                                onChange={(e) => {
                                  let raw = e.target.value.toUpperCase();
                                  raw = raw.replace(/^TR?/, "");
                                  raw = raw.replace(/[^0-9]/g, "");
                                  raw = raw.slice(0, 24);
                                  let formatted = "TR" + raw;
                                  formatted = formatted.match(/.{1,4}/g)?.join(" ") || "";
                                  this.setState({ iban: formatted });
                                }}
                              />
                            ),
                            "iban_hatamesaj",
                            "iban"
                          )}
                        </>
                      )}
                    </div>
                  )}

                  {this.state.reason !== "7" &&
                    this.renderTextareaField(
                      "Açıklama",
                      "t-icon-bubble1",
                      (
                        <textarea
                          className="form-control"
                          id="mesaj"
                          name="mesaj"
                          rows="3"
                          required
                          maxLength="1000"
                          value={this.state.description}
                          onChange={(e) => {
                            this.setState({ description: e.target.value });
                          }}
                          placeholder="Mesajınızı yazınız"
                        />
                      ),
                      "mesaj_hatamesaj",
                      "mesaj"
                    )}

                  <div
                    className={`t-submitDemand-kvkk${
                      this.state.formErrors.kvkk ? " t-submitDemand-kvkk--error" : ""
                    }`}
                  >
                    <input
                      type="checkbox"
                      className="t-kvkkcheckbox"
                      id="onaychecked"
                      checked={this.state.kvkkAccepted}
                      onChange={(e) => {
                        this.setState({
                          kvkkAccepted: e.target.checked,
                          formErrors: { kvkk: "" },
                        });
                      }}
                    />
                    <span className="t-submitDemand-kvkkText">
                      <a id="kvkk-onayla" href="#kvkk-onayla" onClick={this.getKvkk}>
                        KVKK Taahhütnamesi
                      </a>
                      &apos;ni <strong>ONAYLIYORUM</strong>
                    </span>
                  </div>
                  {this.state.formErrors.kvkk ? (
                    <p className="t-resetPassword-error t-submitDemand-kvkkError">
                      {this.state.formErrors.kvkk}
                    </p>
                  ) : null}

                  <div className="t-resetPassword-actions">
                    <button
                      type="submit"
                      className="t-memberInfo-btn t-memberInfo-btn--primary"
                      disabled={showLoadingOverlay}
                    >
                      <span>Mesajımı Gönder</span>
                      <i className="t-icon-arrow-right2" aria-hidden="true" />
                    </button>
                  </div>
                </form>
              </article>
            </div>
          </div>
          <div className="row" style={{ height: 30 }} />

          <KvkkModal
            isOpen={this.state.isKvkkModalOpen}
            onClose={this.closeKvkkModal}
            onLoaded={this.handleKvkkLoaded}
          />

          {showLoadingOverlay && (
            <div className="t-eminevimLoadingOverlay">
              <EminevimLoading subtext={this.getLoadingSubtext()} compact />
            </div>
          )}
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    workflow: selectWorkflow(state),
    memberFek: state.workflow.memberFek,
    memberIban: state.workflow.memberIban,
    isLoading: state.workflow.isLoading || false
  };
};

const mapDispatchToProps = (dispatch) => ({
  addFeedbacks: (subject, description, reason, memberNo, nameSuranme, tckn, fatherName, unvan, vkn, mersisNo, iban, phone) =>
    dispatch(addFeedbacks(subject, description, reason, memberNo, nameSuranme, tckn, fatherName, unvan, vkn, mersisNo, iban, phone)),
  getMemberFeks: (orgTuru) => dispatch(getMemberFeks(orgTuru)),
  getMemberIbans: () => dispatch(getMemberIbans()),
  clearMemberFek: () => dispatch(clearMemberFek()),
  clearMemberIban: () => dispatch(clearMemberIban())
});

export default connect(mapStateToProps, mapDispatchToProps)(SubmitDemand);
